module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-21.83f78d1c.JPG";